var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.4 17.2H12.8V9.3C12.8 8.4 12.5 7.7 11.4 7.7C9.5 7.7 9.2 9.3 9.2 9.3V17.2H5.5V4.5H9.1V5.7C9.6 5.3 10.9 4.5 12.7 4.5C13.9 4.5 16.3 5.2 16.3 9.5V17.2H16.4Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.89995 3.6998C0.999951 3.6998 0.199951 2.8998 0.199951 1.9998C0.199951 0.999805 0.999951 0.299805 1.89995 0.299805C2.89995 0.299805 3.59995 0.999805 3.59995 1.9998C3.59995 2.8998 2.89995 3.6998 1.89995 3.6998Z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.6 17.2H0V4.5H3.6V17.2Z","key":2})]);
}

Linkedin.defaultProps = {"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
